import React from 'react';
import { Button } from '@material-ui/core';

const TITLE = 'Account not active';
const BODY = 'Your account is awaiting approval or has been deactivated. Contact Onward support if you need help.';

/**
 * Full-page splash shown in place of the app when a signed-in account has no Hasura access.
 * @param {object} props
 * @param {() => void} props.onCheckAgain Re-reads the token claims.
 * @param {() => void} props.onSignOut Signs the user out.
 */
const PendingAccess = ({ onCheckAgain, onSignOut }) => {
    return (
        <div style={{ padding: '80px 16px', textAlign: 'center' }}>
            <h3 className="text-center text-danger">{TITLE}</h3>
            <p>{BODY}</p>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '12px', marginTop: '24px' }}>
                <Button variant="contained" color="primary" onClick={onCheckAgain}>
                    Check again
                </Button>
                <Button variant="outlined" onClick={onSignOut}>
                    Sign out
                </Button>
            </div>
        </div>
    );
};

export default PendingAccess;
